import LoadingIndicator, { type LoadingIndicatorProps } from "ds/components/LoadingIndicator";
import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

type PaginationIndicatorProps = {
  currentCount: number;
  totalCount: number;
  loading?: boolean;
  minimumLoadingDuration?: LoadingIndicatorProps["minimumDuration"];
};

/**
 * @deprecated Tables paginated with `TablePagination` already show the loaded range at the bottom,
 * so this header indicator duplicates it. Don't add it to new tables; existing usages go away
 * together with their legacy table layouts.
 */
const PaginationIndicator = ({
  currentCount,
  totalCount,
  loading,
  minimumLoadingDuration,
}: PaginationIndicatorProps) => {
  return (
    <Typography variant="p-body3" tag="div" className={styles.paginationIndicator}>
      <LoadingIndicator
        loading={loading}
        className={styles.loader}
        minimumDuration={minimumLoadingDuration}
      />
      Showing {currentCount} of {totalCount}
    </Typography>
  );
};

export default PaginationIndicator;
